import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import CopyrightIcon from '@mui/icons-material/Copyright';
import ReplyAllIcon from '@mui/icons-material/ReplyAll';


const IncomeExpenseCreate = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const [itemOptions, setItemOptions] = useState([]); // Store available item options
    const [selectedItemOption, setSelectedItemOption] = useState(null);
    const [amount, setAmount] = useState('');
    const [itemsList, setItemsList] = useState([]); // Store added items

    const [modalData, setModalData] = useState(null); // Modal data
    const [tableData, setTableData] = useState([]); // Table data for display


    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchmaxbillno(true);

    }, [isAuthenticated, companyId, token, logout]);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {

            const response = await fetchData('IncomeExpenseApi', `/Master/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleInputChange = (newValue) => newValue;
    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;
    };

    //FOR CHILD 
    const [ChildOptions, setchildOptions] = useState([]);
    const [selectedChildOption, setSelectedChildOption] = useState(null);

    const fetchChildOptions = async (inputValue) => {
        if (inputValue.length <= 3) {
            return [];
        }

        try {
            // const response = await fetchData('JournelEntryAPI', `${companyId}/${branchId}`, token);
            const response = await fetchData('JournelEntryAPI', `/Master/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setchildOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };
    const handleChildInputChange = (newValue) => newValue;
    // Handle customer selection//
    const handleChildSelect = (selectedChildOption) => {
        setSelectedChildOption(selectedChildOption);
        setFormData((prevData) => ({
            ...prevData,
            PartyId: selectedChildOption ? selectedChildOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedChildOption) return;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState(true); // Default to Credit (true)
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNo: '',
        IsType: true, // 1 for Credit, 2 for Debit
    });

    const submitData = async (e) => {
        e.preventDefault(); // Prevent form submission
        setIsLoading(true); // Set loading state

        if (!formData.MasterId || formData.MasterId === 0) {
            setErrorMessage('Master is required!');
            setIsLoading(false);
            return;
        }


        if (!formData.Amount || formData.Amount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

          if (!formData.PaymentType || formData.PaymentType === 0) {
            setErrorMessage('Payment type is required');
            setIsLoading(false);
            return;
        }

        // Validation for non-cash payment types
        if (selectedPaymentmethodType && selectedPaymentmethodType.label !== 'Cash') {
            if (!formData.ChequeNumber) {
                setErrorMessage('Reference No is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.ChequeDate) {
                setErrorMessage('Reference Date is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!formData.chequeDetails) {
                setErrorMessage('Reference Details are required for non-cash payments!');
                setIsLoading(false);
                return;
            }
            if (!selectedBank) {
                setErrorMessage('Bank selection is required for non-cash payments!');
                setIsLoading(false);
                return;
            }
        }

        const updatedFormData = {
            ...formData,
            CreatedBy: userId,
            PaymentType : selectedPaymentmethodType ? selectedPaymentmethodType.value : 1,
        };

        try {
            // API Call
            const response = await postData('IncomeExpenseApi', updatedFormData, token);

            // Success Handling
            setSuccessMessage('Income Expense Created Successfully!');
            setErrorMessage('');
            setFormData({
                ...formData,
                BillDate: '',
                BillNo: 0,
                CustomerId: '',
                PaymentType: '',
                Amount: 0,
                Remarks: '',
                IsType: null,
            });
            setItemsList([]); // Clear the items list
            setIsLoading(false);
            history.push('/IncomeExpenseIndex'); // Redirect to Receipt Index

            // Reset success message after timeout
            setTimeout(() => {
                setSuccessMessage('');
            }, 3000);
        } catch (error) {
            console.error('Incom eExpense Creation Error:', error);

            // Detailed Error Logging
            if (error.response) {
                console.error('Response Data:', error.response.data);
                console.error('Response Status:', error.response.status);
            } else if (error.request) {
                console.error('No Response Received:', error.request);
            } else {
                console.error('Error Setting up Request:', error.message);
            }

            // Show Error Message
            setErrorMessage('Failed to create Journal Entry. Please try again.');
            setIsLoading(false);
        }
    };

    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "IsType"
                ? value === "1"
                : name === "PaymentType"
                    ? Number(value) // Ensure PaymentType is stored as a number
                    : type === "checkbox"
                        ? checked
                        : value,
        }));

        let ispaymentType = true;

        if (name === "IsType") {
            ispaymentType = value === "1";
            setSelectedPaymentType(ispaymentType);
            fetchData('IncomeExpenseApi', `/MaxBillno/${companyId}/${branchId}/${ispaymentType}`, token)
                .then((response) => response.response_data)
                .then((data) => {
                    const currentDate = new Date();
                    const year = currentDate.getFullYear();
                    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                    const day = String(currentDate.getDate()).padStart(2, '0');
                    const formattedDate = `${year}-${month}-${day}`;

                    setFormData(prevData => ({
                        ...prevData,
                        BillNo: data.BillNumber,
                        BillDate: formattedDate,
                        FinYear: data.FinYear,
                        BranchId: branchId,
                        CompanyId: companyId,
                    }));
                })
                .catch((error) => {
                    console.error('Error fetching Max Billno:', error);
                });
        } else {

        }
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time 
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        setFormData((prevData) => ({
            ...prevData,
            BillDate: formattedDate,
            ChequeDate: formattedDate,
            PaymentType: 1,
        }));
    }, []);

    // Function to fetch MaxBillno

    const fetchmaxbillno = (Inputstring) => {
        // Use the parameter directly, no need to rely on formData here
        fetchData('IncomeExpenseApi', `/MaxBillno/${companyId}/${branchId}/${Inputstring}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                // Update formData with the fetched data
                setFormData((prevData) => ({
                    ...prevData,
                    BillNo: data.BillNumber,
                    BillDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Max Billno:', error);
            });
    };

    useEffect(() => {
        fetchmaxbillno(true);
    }, []);

    const parseAndFix = (val) => parseFloat(val) || 0;

    useEffect(() => {
        let amt = parseAndFix(formData.Amount);
        const GSTRate = parseAndFix(formData.GSTRate);
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.IsIGST) {
            igstAmount = ((amt * GSTRate) / 100).toFixed(2);
        } else {
            cgstAmount = ((amt * (GSTRate / 2)) / 100).toFixed(2);
            sgstAmount = ((amt * (GSTRate / 2)) / 100).toFixed(2);
        }

        let netAmount = parseAndFix(amt) + parseAndFix(igstAmount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;

        setFormData((prev) => ({
            ...prev,
            Amount: amt,
            CGSTAmount: parseFloat(cgstAmount).toFixed(2),
            SGSTAmount: parseFloat(sgstAmount).toFixed(2),
            IGSTAmount: parseFloat(igstAmount).toFixed(2),
            RoundOff: parseFloat(roundOff).toFixed(2),
            TotalAmount: parseFloat(grandTotal).toFixed(2),
        }));
    }, [formData.Amount, formData.GSTRate, formData.IsIGST]);
  
    //customer Payment Method 
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");
    const [showBankField, setShowBankField] = useState(true);

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentApi', `/PaymentModes/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
                setShowBankField(true);
            }
        } catch (error) {
            console.error('Error fetching PaymentModes:', error);
        }
    };

    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
        setFormData((prevData) => ({
            ...prevData,            
            PaymentType: selectedOption.value,            
        }));
        if (["Cheque", "RTGS", "NEFT", "UPI"].includes(selectedOption.label)) {
            setShowBankField(false);
        } else {
            setShowBankField(true);
        }
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
    }, []);

    //Bank
    const [bankOptions, setBankOptions] = useState([]);
    const [selectedBank, setSelectedBank] = useState("");

    const fetchBanks = async () => {
        try {
            const response = await fetchData('PaymentApi', `/Banks/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setBankOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Bank:', error);
        }
    };

    const handleBankChange = (selectedOption) => {
        setSelectedBank(selectedOption);
    };

    useEffect(() => {
        fetchBanks();
    }, []);

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '101%', marginTop: '-0.55%' }}>

                <div className="flex flex-wrap justify-between items-center mb-4">
                    <h6
                        className="uppercase tracking-wide text-black font-serif flex-grow"
                        style={{
                            fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                            color: 'black',
                            marginTop: '10px',
                        }}
                    >
                        CREATE INCOME & Expense
                    </h6>
                    <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                        <div className='w-full mb-2 flex'>

                            <label className="block tracking-wide text-gray-700 font-bold" style={{ color: 'darkblue' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="1"
                                    checked={formData.IsType === true}
                                    onChange={handleChange}
                                />
                                INCOME
                            </label>
                            <label className="block tracking-wide text-gray-700 font-bold ml-2" style={{ color: 'brown' }}>
                                <input
                                    type="radio"
                                    name="IsType"
                                    value="0"
                                    checked={formData.IsType === false}
                                    onChange={handleChange}
                                />
                                EXPENSE
                            </label>

                        </div>
                    </div>

                    <div className="flex mt-8 w-full sm:w-auto">

                        <Button
                            style={{
                                background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                            onClick={submitData}
                            disabled={isLoading}
                        >
                            <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                            {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Save</b>}
                        </Button>

                        <Button
                            color="error"
                            component={Link}
                            to={{
                                pathname: "/IncomeExpenseIndex",
                                state: { from: "/IncomeExpenseCreate" },
                            }}
                            onClick={() => {
                                localStorage.setItem('shouldReload', 'true');
                            }}
                            className="linkcolor"
                            style={{
                                background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                                color: 'black',
                                fontWeight: 'bolder',
                                textTransform: 'none',
                                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                maxHeight: '30px',
                                marginLeft: '15px',

                            }}
                        >
                            <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                        </Button>
                    </div>

                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            {successMessage && <p className="text-green-500">{successMessage}</p>}

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>

            <div className="w-full flex flex-wrap md:flex-row flex-col">
                {/* Left Section: Entry Fields */}
                <div
                    className="flex-1 p-4"
                    style={{
                        backgroundColor: '#f3f3f3',
                        borderRadius: '10px',
                        marginTop: '-10px',
                    }}
                >
                    <div className="mb-3">
                        <div className="w-full mb-2 flex">
                            <div className="w-4/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="customer">
                                    Master <span className="text-red-500">*</span>
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchOptions}
                                    onInputChange={handleInputChange}
                                    onChange={handleCustomerSelect}
                                    value={selectedOption}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                    Date <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="date"
                                    value={formatDateForInput(formData.BillDate)}
                                    name="BillDate"
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    Bill Number <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={`${formData.BillNo || ''}/${formData.FinYear || ''}`}
                                    name="BillNo"
                                    readOnly
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label
                                    className="block uppercase tracking-wide text-black text-xs font-bold mb-2 flex items-center gap-x-2"
                                    htmlFor="gstPercentage"
                                >
                                    GST %
                                    <input
                                        type="checkbox"
                                        className="form-checkbox h-4 w-4 text-red-700"
                                        name="IsIGST"
                                        checked={formData.IsIGST || false}
                                        onChange={handleChange}
                                        style={{ marginLeft: '10px' }}
                                    />
                                    <span className="text-xs text-red-700" style={{ marginLeft: '5px' }}>IGST</span>
                                </label>
                                <select
                                    className="shadow border rounded w-full py-2 px-3 text-black-700 leading-tight focus:shadow-outline"
                                    name="GSTRate"
                                    value={formData.GSTRate || 0}
                                    onChange={handleChange}
                                >
                                    <option value={0}>0</option>
                                    <option value={3}>3</option>
                                    <option value={5}>5</option>
                                    <option value={12}>12</option>
                                    <option value={18}>18</option>
                                    <option value={28}>28</option>
                                </select>
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="amount">
                                    Amount
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline text-right"
                                    type="number"
                                    value={formData.Amount}
                                    name="Amount"
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                        <div className="flex flex-wrap items-center gap-x-4 mt-3">
                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    CGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.CGSTAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    SGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.SGSTAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    IGST : <span style={{ color: 'red', fontSize: '14px' }}>{formData.IGSTAmount}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    R.Off : <span style={{ color: 'red', fontSize: '14px' }}>{formData.RoundOff}</span>
                                </label>
                            </div>

                            <div className="w-1/6 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Total : <span style={{ color: 'red', fontSize: '14px' }}>{formData.TotalAmount}</span>
                                </label>
                            </div>
                        </div>

                        <div className="w-full mb-2 flex">

                            <div className="w-4/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                    Party
                                    <span className="text-red-500">*</span>
                                </label>
                                <AsyncSelect
                                    cacheOptions
                                    loadOptions={fetchChildOptions}
                                    onInputChange={handleChildInputChange}
                                    onChange={handleChildSelect}
                                    value={selectedChildOption}
                                />
                            </div>


                            <div className="w-4/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="remarks">
                                    Remarks
                                </label>
                                <input
                                    className="shadow border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:shadow-outline"
                                    type="text"
                                    value={formData.Remarks}
                                    name="Remarks"
                                    onChange={handleChange}
                                />
                            </div>



                        </div>
                        <div className="w-full mb-2 flex">

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                    Payment Mode
                                </label>

                                <Select
                                    value={selectedPaymentmethodType || { value: 'cash', label: 'Cash' }}  // Default to "Cash" if not selected
                                    onChange={handlePaymentTypeChange}
                                    options={paymentmethodOptions}
                                    placeholder="PaymentOption"
                                    isSearchable
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '35px',
                                            minHeight: '35px',
                                            fontSize: '14px',
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                    }}
                                />
                            </div>

                            <div className="w-1/5 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Bank' : 'Bank'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <Select
                                    value={selectedBank || { value: '', label: 'Select Bank' }}
                                    onChange={handleBankChange}
                                    options={bankOptions}
                                    placeholder="Select Bank"
                                    isSearchable
                                    isDisabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                    styles={{
                                        control: (base) => ({
                                            ...base,
                                            height: '35px',
                                            minHeight: '35px',
                                            fontSize: '14px',
                                        }),
                                        input: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                        singleValue: (base) => ({
                                            ...base,
                                            fontSize: '14px',
                                        }),
                                    }}
                                />
                            </div>

                            <div className="w-1/6 mr-2">

                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque No' : 'Reference No'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.ChequeNumber}
                                    type="text"
                                    placeholder=""
                                    name="ChequeNumber"
                                    onChange={handleChange}
                                    style={{ height: '35px' }}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                />
                            </div>

                            <div className="w-1/8 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Date' : 'Reference Date'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formatDateForInput(formData.ChequeDate)}
                                    type="date"
                                    placeholder=""
                                    name="ChequeDate"
                                    onChange={handleChange}
                                    style={{ height: '35px' }}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                />
                            </div>

                            <div className="w-1/4 mr-2">
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                    {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                    <span className="text-red-500">*</span>
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.chequeDetails}
                                    type="text"
                                    placeholder=""
                                    name="chequeDetails"
                                    onChange={handleChange}
                                    style={{ height: '35px' }}
                                    disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                                />
                            </div>

                        </div>
                    </div>
                </div>

            </div>



        </Fragment >
    );
};


export default IncomeExpenseCreate;
